import React from 'react';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';
import { connect } from 'react-redux';
import { isEmpty as _isEmpty } from 'lodash';

import MatchTeams from 'newDesign/modules/announcement/components/matchTeams/MatchTeams';
import MatchOdds from 'newDesign/modules/announcement/components/matchOdds/MatchOdds';
import SportInfoCmp from 'newDesign/modules/announcement/components/sportInfoCmp/SportInfo';
import TournamentInfo from 'newDesign/modules/announcement/components/tournamentInfo/TournamentInfo';
import {
  getMatchStatus,
  getShowOdds,
  getBgColor,
  getMatchTennisDouble,
} from 'reducers';
import { twoOrThreeWayUOF } from 'constants/enum';

import style from 'newDesign/modules/announcement/components/match/Match.scss';

const mapStateToProps = (state, ownProps) => ({
  matchStatus: getMatchStatus(state, ownProps.matchId),
  showOdds: getShowOdds(state),
  bgColor: getBgColor(state),
  tennisDouble: getMatchTennisDouble(state, ownProps.matchId),
});

const Match = ({
  matchId, matchStatus, showOdds, tennisDouble,
}) => (
  <div className={`event ${!_isEmpty(tennisDouble) && style.event__doubles} my-5`}>
    <div
      styleName='event__meta'
      className={'flex justify-center items-stretch'}
    >
      <SportInfoCmp matchId={matchId} />
    </div>
    <MatchTeams matchId={matchId} />
    <div styleName='event__meta' className='flex justify-center items-stretch gap-x-20 fs-17'>
      <TournamentInfo matchId={matchId} />
      {showOdds ? (
        <MatchOdds
          matchStatus={matchStatus}
          matchId={matchId}
          marketIds={twoOrThreeWayUOF}
          maxMarkets={1}
          useFeedOutcomes
        />
      ) : null}
    </div>
  </div>
);

Match.propTypes = {
  showOdds: PropTypes.bool.isRequired,
  matchStatus: PropTypes.number,
  matchId: PropTypes.number.isRequired,
  tennisDouble: PropTypes.object,
};

Match.defaultProps = {
  matchStatus: null,
  tennisDouble: {},
};

const MatchStyled = cssModule(Match, style);
export default connect(mapStateToProps)(MatchStyled);
